export enum AccountType {
	Student = 'student',
	Professional = 'professional',
}